/* ++++++++++ --------------- CheckListSection STYLES --------------- ++++++++++ */
import {pxToEm, themeV2} from "@insticator/insticator-ui";

export default theme => ({
    checklistSection : {
        overflow: "hidden",
        display: 'flex',
        flexDirection: 'row',
        borderRadius: pxToEm(12),
        border: '1px solid #E7ECF7',
        '& > .listSection': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 0',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            borderRight: '1px solid #E7ECF7',
            backgroundColor: 'white',
            '& > .titlesection': {
                display: 'flex',
                padding: pxToEm(20),
                flexDirection: 'column',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                gap: pxToEm(12),
                borderBottom: '1px solid #E7ECF7',
                '& > .title': {
                    color: '#061240',
                    fontVariantNumeric: 'lining-nums proportional-nums',
                    fontWeight: '500',
                    fontStyle: 'normal',
                    fontSize: pxToEm(16),
                    fontFamily: "Work Sans",
                    lineHeight: pxToEm(22),
                },
            },
            '& > .section': {
                width: '100%',
                '& > .checkListSection': {
                    width: '100%',
                }
            },

        },
        '& > .selectedSection': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 0',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            borderRight: '1px solid #E7ECF7',
            backgroundColor: '#FAFBFC',
            maxWidth: pxToEm(320),
            width: '100%',
            '& > .titlesection': {
                display: 'flex',
                padding: pxToEm(20),
                flexDirection: 'row',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                gap: pxToEm(12),
                borderBottom: '1px solid #E7ECF7',
                '& > .title': {
                    color: '#061240',
                    fontVariantNumeric: 'lining-nums proportional-nums',
                    fontWeight: '500',
                    fontStyle: 'normal',
                    fontSize: pxToEm(16),
                    fontFamily: 'Work Sans',
                    lineHeight: pxToEm(22),
                },
                '& > .clearall': {
                    marginLeft: 'auto',
                    color: '#3257EC',
                    fontFamily: "Work Sans",
                    fontSize: pxToEm(14),
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: 'normal',
                    'text-decoration-line': 'underline',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                }
            },
            '& > .section':{
                width: '100%',
                backgroundColor: '#FAFBFC',
                '& > .scrollableHeight' :{
                    height: pxToEm(560),
                }
            }
        },
    },
    '@global': {
        '.MuiListItemButton-root' : {
            padding : '0 !important',
        },
        '.MuiCheckbox-root': {
            paddingRight : '8px !important',
            paddingLeft : '8px !important',
            paddingTop : '3px !important',
            paddingBottom: '3px !important',
            color: '#061240 !important',
            '& > svg':{
                fill : '#AFBCD5'
            }

        },
        '.Mui-checked': {
            '& > svg': {
                fill : '#061240'
            }

        }
},
});